import { appSync, startListening } from '@betty/toolkit/state';
import { fetchBanners, selectBannersDataState } from './Banners.slice';

startListening({
  actionCreator: appSync,
  effect: (_, { dispatch, getState }) => {
    const dataState = selectBannersDataState(getState());

    if (dataState === 'fulfilled' || dataState === 'rejected') {
      dispatch(fetchBanners());
    }
  },
});
